<template>
  <div>
    <SidebarVue ref="sidebar" />
    <Navgator
      ref="navgator"
      :barraTitulo="' Administração - Acessórios'"
      :titulo="'acessório'"
    />

    <!--Formulário de Cadastro -->
    <div class="card-container">
      <div class="card">
        <div class="row g-2 p-2">
          <div class="card-title gy-4">
            <i class="bi bi-journal-text fs-5 icon-text-form"></i>
            <span class="txt-title-form">Dados do Acessório</span>
          </div>
        </div>
        <form @submit.prevent="onSubmit">
          <div class="row g-2 p-2">
            <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
              <div class="form-floating txt-form-label">
                <select
                  class="form-select txt-form-input"
                  v-model="item"
                  required
                >
                  <option value="0">INTERNO</option>
                  <option value="1">EXTERNO</option>
                </select>
                <label>Item</label>
              </div>
            </div>

            <!-- Cortesia (25%) -->
            <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
              <div class="form-floating txt-form-label">
                <select
                  class="form-select txt-form-input"
                  v-model="cortesia"
                  required
                >
                  <option value="NAO">NAO</option>
                  <option value="SIM">SIM</option>
                </select>
                <label>Cortesia</label>
              </div>
            </div>

            <!-- Preço Base (25%) -->
            <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
              <div class="form-floating txt-form-label">
                <input
                  type="text"
                  class="form-control txt-form-input"
                  v-model="preco_base_peca"
                  @input="preco_base_peca = formatarValor(preco_base_peca)"
                  required
                />
                <label>Preço Base</label>
              </div>
            </div>

            <!-- Código (25%) -->
            <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
              <div class="form-floating txt-form-label">
                <input
                  type="text"
                  class="form-control txt-form-input"
                  v-model="codigo"
                  required
                />
                <label>Código</label>
              </div>
            </div>

            <!-- Descrição (50%) - Só ocupa metade em XL, mas 100% nos outros -->
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <div class="form-floating txt-form-label">
                <input
                  type="text"
                  class="form-control txt-form-input"
                  v-model="descricao"
                  required
                />
                <label>Descrição</label>
              </div>
            </div>
          </div>
          <!-- Segunda Linha -->
          <div class="row g-2 p-2">
            <!-- Tmo Instalação -->
            <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4">
              <div class="form-floating txt-form-label">
                <input
                  type="text"
                  class="form-control txt-form-input"
                  v-model="tmo_instalação"
                  required
                />
                <label>Tmo. Instalação</label>
              </div>
            </div>

            <!-- Tmo Pintura -->
            <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4">
              <div class="form-floating txt-form-label">
                <input
                  type="text"
                  class="form-control txt-form-input"
                  v-model="tmo_pintura"
                  required
                />
                <label>Tmo. Pintura</label>
              </div>
            </div>

            <!-- Preço Final -->
            <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4">
              <div class="form-floating txt-form-label">
                <input
                  type="text"
                  class="form-control txt-form-input"
                  v-model="preco_final_instalado"
                  @input="
                    preco_final_instalado = formatarValor(preco_final_instalado)
                  "
                  required
                />
                <label>Preço Final</label>
              </div>
            </div>

            <!-- Categoria -->
            <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4">
              <div class="form-floating txt-form-label">
                <select
                  class="form-select txt-form-input"
                  v-model="categoria_id"
                  required
                >
                  <option value="1">Novos</option>
                  <option value="2">Usados</option>
                </select>
                <label>Categoria</label>
              </div>
            </div>

            <!-- Modelo -->
            <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4">
              <div class="form-floating txt-form-label">
                <select
                  class="form-select txt-form-input"
                  v-model="modelo_id"
                  required
                >
                  <option
                    v-for="item in modelo"
                    :value="item.id"
                    :key="item.id"
                  >
                    {{ item.descricao }}
                  </option>
                </select>
                <label>Modelo</label>
              </div>
            </div>

            <!-- Mão de Obra -->
            <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4">
              <div class="form-floating txt-form-label">
                <select
                  class="form-select txt-form-input"
                  v-model="mao_obra_id"
                  required
                >
                  <option value="4">Ambos</option>
                  <option value="1">Instalação</option>
                  <option value="2">Pintura</option>
                </select>
                <label>Mão de Obra</label>
              </div>
            </div>

            <!-- Botão Cadastrar -->
            <div class="d-md-none">
              <div
                class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 d-flex justify-content-end"
              >
                <button
                  type="submit"
                  :disabled="btn_cadastrar"
                  class="btn round-btn"
                >
                  <i class="bi bi-plus-circle" title="Inserir Acessório"></i>
                </button>
              </div>
            </div>
            <div class="d-none d-md-block">
              <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4">
                <button
                  type="submit"
                  :disabled="btn_cadastrar"
                  class="btn btn-lg btn-form align-self-end"
                >
                  <span>Cadastrar</span>
                </button>
              </div>
            </div>
          </div>
        </form>
        <div v-if="abrir_modal">
          <Message :msg="msg" v-show="msg" />
        </div>
      </div>
    </div>

    <!--Tabela-->
    <div class="card-container">
      <div class="card">
        <!--Apenas Mobile-->
        <div class="d-md-none">
          <div v-if="isLoading" class="text-center my-4">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Carregando...</span>
            </div>
          </div>
          <div v-else>
            <div
              v-for="item in acessorios"
              :key="item.descricao"
              class="accordion mb-2"
            >
              <div class="accordion-item">
                <button
                  class="accordion-button collapsed card-table-txt"
                  data-bs-toggle="collapse"
                  :data-bs-target="'#row-' + item.id"
                >
                  {{ item.descricao }}
                </button>
                <div :id="'row-' + item.id" class="accordion-collapse collapse">
                  <div class="accordion-body">
                    <p class="card-table-item">
                      <strong>Preço Base:</strong>
                      {{ currency(item.preco_base_peca) }}
                    </p>
                    <p class="card-table-item">
                      <strong>Preço Instalado:</strong>
                      {{ currency(item.preco_final_instalado) }}
                    </p>
                    <button
                      type="button"
                      class="btn round-btn align-self-end"
                      data-bs-toggle="modal"
                      data-bs-target="#exampleModal"
                      @click="editar_acessorio(item)"
                    >
                      <i class="bi bi-pencil-square"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--Apenas Tablet-->
        <div class="d-none d-md-block d-lg-none">
          <div v-if="isLoading" class="text-center my-4">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Carregando...</span>
            </div>
          </div>
          <div v-else>
            <div
              v-for="item in acessorios"
              :key="item.descricao"
              class="accordion mb-2"
            >
              <div class="accordion-item">
                <button
                  class="accordion-button collapsed card-table-txt"
                  data-bs-toggle="collapse"
                  :data-bs-target="'#row-' + item.id"
                >
                  {{ item.descricao }}
                </button>
                <div :id="'row-' + item.id" class="accordion-collapse collapse">
                  <div class="accordion-body">
                    <p class="card-table-item">
                      <strong>Preço Base:</strong>
                      {{ currency(item.preco_base_peca) }}
                    </p>
                    <p class="card-table-item">
                      <strong>Preço Instalado:</strong>
                      {{ currency(item.preco_final_instalado) }}
                    </p>
                    <button
                      type="button"
                      class="btn btn-modal"
                      data-bs-toggle="modal"
                      data-bs-target="#exampleModal"
                      @click="editar_acessorio(item)"
                    >
                      <span>Editar</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--Apenas Desktop -->
        <div class="d-none d-lg-block">
          <table class="table rf_texto table-striped" v-if="!isLoading">
            <thead class="d-md-table-header-group">
              <!-- Oculta cabeçalho em mobile -->
              <tr>
                <th scope="col" class="col-md-4 col-lg-3">Descrição</th>
                <th scope="col" class="col-md-2 col-lg-2">Preço Base</th>
                <th scope="col" class="col-md-3 col-lg-3">Preço Instalado</th>
                <th scope="col" class="col-md-1 col-lg-1 text-center">Ação</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in acessorios"
                :key="item.descricao"
                class="table-linha"
              >
                <!-- Celula de Descrição (com cabeçalho para mobile) -->
                <td data-label="Descrição" class="col-12 col-md-4 col-lg-3">
                  <span class="d-md-none fw-bold">Descrição: </span>
                  {{ item.descricao }}
                </td>

                <!-- Celula de Preço Base -->
                <td data-label="Preço Base" class="col-6 col-md-2 col-lg-2">
                  <span class="d-md-none fw-bold">Preço Base: </span>
                  {{ this.currency(item.preco_base_peca) }}
                </td>

                <!-- Celula de Preço Instalado -->
                <td
                  data-label="Preço Instalado"
                  class="col-6 col-md-3 col-lg-3"
                >
                  <span class="d-md-none fw-bold">Preço Instalado: </span>
                  {{ this.currency(item.preco_final_instalado) }}
                </td>

                <!-- Celula de Ação -->
                <td class="col-12 col-md-1 col-lg-1 text-center text-md-start">
                  <button
                    type="button"
                    class="dropdown-toggle-icon btn-sm"
                    data-bs-toggle="modal"
                    data-bs-target="#exampleModal"
                    @click="editar_acessorio(item)"
                  >
                    <i class="bi bi-pencil-square"></i>
                    <span class="d-md-none">Editar</span>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <div v-else class="loading-indicator">Carregando...</div>
        </div>
        <pagination
          v-if="acessorios.length"
          :total="totalItems"
          :limit="pageSize"
          :offset="currentPage"
          :totalPages="Math.ceil(totalItems / pageSize)"
          @change-page="handlePageChange"
        />
      </div>
    </div>

    <!-- Modal para edição -->
    <div
      class="modal fade"
      id="exampleModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-xl">
        <div class="modal-content card-container">
          <div class="modal-header">
            <i class="bi bi-pencil-square icon-text-logout"></i>
            <span class="txt-title-modal"> Editar Acessório</span>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body txt-body-modal">
            <div class="row g-2 p-2">
              <!--Item-->
              <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
                <div class="form-floating txt-form-label">
                  <select
                    class="form-select txt-form-input"
                    v-model="edit_item"
                  >
                    <option value="0">INTERNO</option>
                    <option value="1">EXTERNO</option>
                  </select>
                  <label for="valid_status">Item</label>
                </div>
              </div>
              <!--Cortesia-->
              <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
                <div class="form-floating txt-form-label">
                  <select
                    class="form-select txt-form-input"
                    v-model="edit_cortesia"
                  >
                    <option value="NAO">NAO</option>
                    <option value="SIM">SIM</option>
                  </select>
                  <label>Cortesia</label>
                </div>
              </div>
              <!--Preço Base-->
              <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="edit_preco_base_peca"
                    @input="
                      edit_preco_base_peca = formatarValor(edit_preco_base_peca)
                    "
                  />
                  <label>Preço Base</label>
                </div>
              </div>
              <!--Código-->
              <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="edit_codigo"
                  />
                  <label>Código</label>
                </div>
              </div>
              <!--Descrição-->
              <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="edit_descricao"
                  />
                  <label>Descrição</label>
                </div>
              </div>
            </div>
            <div class="row g-2 p-2">
              <!--Tmo Instalação-->
              <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="edit_tmo_inst"
                  />
                  <label>Tmo. Instalação</label>
                </div>
              </div>
              <!--Tmo Pintura-->
              <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="edit_tmo_pintura"
                  />
                  <label class="rf_texto">Tmo. Pintura</label>
                </div>
              </div>
              <!--Item-->
              <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="edit_preco_final_instalado"
                    @input="
                      edit_preco_final_instalado = formatarValor(
                        edit_preco_final_instalado
                      )
                    "
                  />
                  <label>Preço Instalação</label>
                </div>
              </div>
              <!--Categoria-->
              <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4">
                <div class="form-floating txt-form-label">
                  <select
                    class="form-select txt-form-input"
                    v-model="edit_categoria_id"
                    id="valid_status"
                    required
                  >
                    <option value="1">Novos</option>
                    <option value="2">Usados</option>
                  </select>
                  <label>Categoria</label>
                </div>
              </div>
              <!--Modelo-->
              <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4">
                <div class="form-floating txt-form-label">
                  <select
                    class="form-select txt-form-input"
                    v-model="edit_modelo_id"
                  >
                    <option
                      v-for="item in modelo"
                      :value="item.id"
                      :key="item.id"
                    >
                      {{ item.descricao }}
                    </option>
                  </select>
                  <label>Modelo</label>
                </div>
              </div>
              <!--Mão de Obra-->
              <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4">
                <div class="form-floating txt-form-label">
                  <select
                    class="form-select txt-form-input"
                    v-model="edit_mao_obra_id"
                  >
                    <option value="4">Ambos</option>
                    <option value="1">Instalação</option>
                    <option value="2">Pintura</option>
                  </select>
                  <label>Mão de Obra</label>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="d-md-none">
              <div class="row">
                <div class="col-6">
                  <button
                    type="button"
                    class="btn round-btn"
                    data-bs-dismiss="modal"
                  >
                    <i class="bi bi-x-circle" title="Cancelar"></i>
                  </button>
                </div>
                <div class="col-6">
                  <button
                    type="button"
                    class="btn round-btn"
                    @click="update()"
                    data-bs-dismiss="modal"
                  >
                    <i class="bi bi-check-circle" title="Confirmar"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="d-none d-md-block">
              <div class="row">
                <div class="col-6">
                  <button
                    type="button"
                    class="btn btn-modal"
                    data-bs-dismiss="modal"
                  >
                    Cancelar
                  </button>
                </div>
                <div class="col-6">
                  <button
                    type="button"
                    class="btn btn-modal"
                    data-bs-dismiss="modal"
                    @click="update()"
                  >
                    Confirmar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <RodapeVue />
  </div>
</template>

<script>
import SidebarVue from "../../components/menu/Sidebar.vue";
import Navgator from "../../components/menu/Navgator.vue";
import axios from "axios";
//import DataService from "../../services/DataService";
import userService from "../../services/user.service";
import Pagination from "../../components/Pagination.vue";
import Message from "../../components/modal/Message.vue";

import RodapeVue from "../../components/menu/Rodape.vue";

export default {
  name: "Usuários",
  components: {
    SidebarVue,
    Pagination,
    Message,
    RodapeVue,
    Navgator
  },
  data() {
    return {
      isLoading: false,
      acessorios: [],
      modelo: [],

      //Mensagens do Sistema
      msg: null,
      abrir_modal: false,
      dialog: false,
      //Campos Cadastro
      user_id: "",
      item: "",
      cortesia: "",
      codigo: "",
      descricao: "",
      preco_base_peca: "",
      tmo_instalação: "",
      tmo_pintura: "",
      preco_final_instalado: "",
      categoria_id: "",
      modelo_id: "",
      mao_obra_id: "",
      btn_cadastrar: false,

      /// Campos Modal Editar
      edit_id: "",
      edit_item: "",
      edit_cortesia: "",
      edit_codigo: "",
      edit_descricao: "",
      edit_preco_base_peca: "",
      edit_tmo_inst: "",
      edit_tmo_pintura: "",
      edit_preco_final_instalado: "",
      edit_categoria_id: "",
      edit_modelo_id: "",
      edit_mao_obra_id: "",

      //Params
      searchTitle: "",
      page: 1,
      totalPages: 0,
      totalItems: 0,
      pageSizes: [5, 10, 15, 35],
      pageSize: 50,

      checar: 0
    };
  },
  mounted() {
    this.retrieveAcessorios();
    this.retrieveModelo();
  },
  methods: {
    formatarValor(valor) {
      if (!valor) return "";
      valor = valor.toString().replace(/\D/g, "");
      valor = (valor / 100).toFixed(2).replace(".", ",");
      valor = valor.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      return valor;
    },
    async onSubmit() {
      try {
        const response = await fetch(
          `${process.env.VUE_APP_API_URL}acessorios`,
          {
            method: "POST",

            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              item: this.item,
              cortesia: this.cortesia,
              codigo: this.codigo,
              descricao: this.descricao,
              preco_base_peca: this.preco_base_peca,
              tmo_instalacao: this.tmo_instalação,
              tmo_pintura: this.tmo_pintura,
              preco_final_instalado: this.preco_final_instalado,
              categoria_id: this.categoria_id,
              modelo_id: this.modelo_id,
              mao_obra_id: this.mao_obra_id
            })
          }
        );
        const resp = JSON.stringify(response.status);
        if (resp == 200) {
          this.abrir_modal = true;
          this.msg = "Acessório criado com sucesso!";
          setTimeout(() => (this.abrir_modal = false), 4000);
          (this.item = ""),
            (this.cortesia = ""),
            (this.codigo = ""),
            (this.descricao = ""),
            (this.preco_base_peca = ""),
            (this.tmo_instalação = ""),
            (this.tmo_pintura = ""),
            (this.preco_final_instalado = ""),
            (this.categoria_id = ""),
            (this.modelo_id = ""),
            (this.mao_obra_id = "");
          this.retrieveAcessorios();
        } else {
          this.modal = true;
          this.dialog = true;
          this.message = "Erro ao inserir o acessório";
          setTimeout(() => (this.dialog = false), 4000);
        }
      } catch (error) {
        if (error.response.status == 400) {
          this.abrir_modal = true;
          this.msg = error.response.data.message;
        }
      }
    },
    //Buscar dados no banco de dados
    getRequestParams(searchTitle, page, pageSize) {
      let params = {};
      if (searchTitle) {
        params["nome"] = searchTitle;
      }
      if (page) {
        params["page"] = page - 1;
      }
      if (pageSize) {
        params["size"] = pageSize;
      }
      return params;
    },

    async handlePageChange(newPage) {
      if (this.isLoading) return;

      this.isLoading = true;
      try {
        await this.retrieveAcessorios(newPage);
        this.page = newPage;
      } finally {
        this.isLoading = false;
      }
    },
    handlePageSizeChange(size) {
      this.pageSize = size;
      this.page = 1;
      this.retrieveAcessorios();
    },
    async retrieveAcessorios(page = this.page) {
      try {
        const params = this.getRequestParams(
          this.searchTitle,
          page,
          this.pageSize
        );
        const response = await userService.getAcessorios(params);

        const { acessorios, totalPages, totalItems } = response.data;
        this.acessorios = acessorios;
        this.totalPages = totalPages;
        this.totalItems = totalItems;
        console.log(response.data);
        return true; // Indica sucesso
      } catch (error) {
        console.error("Erro ao buscar clientes:", error);
        if (error.response?.status === 400) {
          this.abrir_modal = true;
          this.msg = error.response.data.message;
        }
        return false; // Indica falha
      }
    },
    async retrieveModelo() {
      try {
        const params = this.getRequestParams(
          this.searchTitle,
          this.page,
          this.pageSize
        );
        userService.getModelo(params).then((response) => {
          const { modelo_veiculo, totalPages } = response.data;
          this.modelo = modelo_veiculo;
          this.totalPages = totalPages;
          console.log(response.data);
        });
      } catch (error) {
        if (error.response.status == 400) {
          this.abrir_modal = true;
          this.msg = error.response.data.message;
        }
      }
    },

    async editar_acessorio(item) {
      console.log(item);
      (this.edit_id = item.id),
        (this.edit_item = item.item),
        (this.edit_cortesia = item.cortesia),
        (this.edit_codigo = item.codigo),
        (this.edit_descricao = item.descricao),
        (this.edit_tmo_inst = item.tmo_instalacao),
        (this.edit_tmo_pintura = item.tmo_pintura),
        (this.edit_preco_final_instalado = this.currency(
          item.preco_final_instalado
        )),
        (this.edit_categoria_id = item.categoria_id),
        (this.edit_modelo_id = item.modelo_id),
        (this.edit_mao_obra_id = item.mao_obra_id);
      this.edit_preco_base_peca = this.currency(item.preco_base_peca);
    },
    async update() {
      const token = this.$store.state.auth.user.accessToken;
      const headers = {
        "x-access-token": token
      };
      const dados = {
        id: this.edit_id,
        item: this.edit_item,
        cortesia: this.edit_cortesia,
        codigo: this.edit_codigo,
        descricao: this.edit_descricao,
        preco_base_peca: this.edit_preco_base_peca,
        tmo_instalacao: this.edit_tmo_inst,
        tmo_pintura: this.edit_tmo_pintura,
        preco_final_instalado: this.edit_preco_final_instalado,
        categoria_id: this.edit_categoria_id,
        modelo_id: this.edit_modelo_id,
        mao_obra_id: this.edit_mao_obra_id
      };

      const response = await axios.put(
        `${process.env.VUE_APP_API_URL}acessorios/${this.edit_id}`,
        dados,
        { headers }
      );
      const resp = JSON.stringify(response.status);
      console.log(resp);
      if (resp == 200) {
        this.abrir_modal = true;
        this.msg = "Acessório atualizado com sucesso!";
        setTimeout(() => (this.abrir_modal = false), 4000);
        location.reload();
      }
    },
    currency(number) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2
      }).format(number);
    }
  }
};
</script>
